// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"a21ae5a9","153":"3ee539dc","376":"82727528","444":"82727528","833":"82727528","861":"c272f750"}[chunkId] + ".chunk.css";
};